// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "button-1ozQR";
var _3 = "buttons-3_Gsh";
export { _1 as "__esModule", _2 as "button", _3 as "buttons" }
export default { "__esModule": _1, "button": _2, "buttons": _3 }
